// extracted by mini-css-extract-plugin
module.exports = {"api-webhooks-empty-state":"webhooks_api-webhooks-empty-state__i2Y5x"};